import { System } from '@ecs/System';
import { ShieldDisplay } from '@components/ShieldDisplay';
import { Shield } from '@components/Shield';

export class ShieldLogicSystem extends System {
  update(_deltaTime: number): void {
    // Update shield display for all entities with shields
    const entities = this.getEntitiesWithComponents(Shield, ShieldDisplay);
    
    for (const entity of entities) {
      const shield = entity.getComponent(Shield)!;
      const shieldDisplay = entity.getComponent(ShieldDisplay)!;
      
      // Determine if shield should be visible
      shieldDisplay.showShield = shield.current > 0;
      
      if (shieldDisplay.showShield) {
        // Calculate shield opacity based on shield strength
        const shieldPercentage = shield.current / shield.max;
        shieldDisplay.shieldOpacity = 0.3 + (shieldPercentage * 0.4); // 0.3 to 0.7
        
        // Add pulse effect when shield is regenerating
        const timeWithoutDamage = Date.now() - shield.lastDamageTime;
        const isRegenerating = timeWithoutDamage > shield.regenDelay && shield.current < shield.max;
        
        if (isRegenerating) {
          shieldDisplay.pulseIntensity = 0.1 * Math.sin(Date.now() * 0.003);
        } else {
          shieldDisplay.pulseIntensity = 0;
        }
      }
    }
  }
}
